import { ICurrentUser } from '@/graphql/operations/user';
import { ResourceUIType } from '@/service/Api/types';

export const getPeopleMenuPath = (currentUser: ICurrentUser): '/users' | '/employees' => {
  const hasEmployeesFeatureEnabled = !!currentUser.organization.config.enableEmployeeDashboardOverride;
  const hasEmployeesAccessRole = !!(currentUser.permissions?.isAdmin || currentUser.permissions?.isManager);
  const hasSchedulesReadAccess = !!currentUser.permissions?.layoutAccess?.some(
    (permission) => permission.resource === ResourceUIType.Schedules && permission.can.includes('read')
  );

  return hasEmployeesFeatureEnabled && hasEmployeesAccessRole && hasSchedulesReadAccess ? '/employees' : '/users';
};
